import ApiCore from './api-core'
import { IDENTIFY } from '@/constants/api-types'

export default class Transaction extends ApiCore {
  constructor(store) {
    const path = `${IDENTIFY}/transaction/credit`
    super(store, path)
  }

  report(filter, showProgress) {
    return this.request({
      action: 'report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  getBalance(showProgress) {
    return this.request({
      action: 'balance',
      method: 'GET',
      showProgress
    })
  }
}
